"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useGetSearchResultsData = void 0;
var _configurationManager = require("@ori/configuration-manager");
var _presentationHttp = require("@ori/presentation-http");
var _react = require("react");
var _constants = require("../constants");
var _loadSearchResultsData = require("./loadSearchResultsData");
var _mapSearchResultsQueryToContentItems = require("./mapSearchResultsQueryToContentItems");
/* istanbul ignore file @preserve */ const useGetSearchResultsData = (param)=>{
    let { query } = param;
    const { graphQlNetUrl } = (0, _configurationManager.useServiceUrls)([
        'graphQlNet'
    ]);
    const { headers } = (0, _presentationHttp.useHeaders)();
    const getSearchResultsData = (0, _react.useCallback)(async (param)=>{
        let { skip, limit = _constants.PAGINATION_LIMIT_ROWS, orderBy, facetFiltering } = param;
        const response = await (0, _loadSearchResultsData.loadSearchResultsData)({
            limit,
            skip,
            query,
            orderBy,
            graphQlNetUrl,
            headers,
            facetFiltering
        });
        return (0, _mapSearchResultsQueryToContentItems.mapSearchResultsQueryToContentItems)(response);
    }, [
        graphQlNetUrl,
        headers,
        query
    ]);
    return {
        getSearchResultsData
    };
};
exports.useGetSearchResultsData = useGetSearchResultsData;
